(function() {
  var CancelDialog, SelectBox,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SelectBox = App.loadClass("core::SelectBox");

  CancelDialog = App.loadClass("core::CancelDialog");

  exports.RuppOrdersHandler = (function(superClass) {
    extend(RuppOrdersHandler, superClass);

    function RuppOrdersHandler() {
      this.orderCompleted = bind(this.orderCompleted, this);
      this.filterOrder = bind(this.filterOrder, this);
      this.filterCrop = bind(this.filterCrop, this);
      return RuppOrdersHandler.__super__.constructor.apply(this, arguments);
    }

    RuppOrdersHandler.prototype.init = function() {
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout';
      this.layoutSelector = App.sidebar.contentDiv();
      this.subHandlers = {
        'Orders_Delete': {
          "class": 'grower::handlers/rupp_orders/RuppOrdersDeleteDialogHandler'
        }
      };
      return this.loadLayout();
    };

    RuppOrdersHandler.prototype.afterLoadLayout = function(selector, response) {
      var crops, orders, ref, years;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      $('#orders_year_filter').bind('change', (function(_this) {
        return function() {
          _this.filterCrop();
          return _this.filterOrder();
        };
      })(this));
      $('#orders_crop_filter').bind('change', this.filterOrder);
      $('#orders_order_filter').bind('change', function() {
        if ($(this).val()) {
          return $('.orders-filter-btn').removeClass('disabled');
        } else {
          return $('.orders-filter-btn').addClass('disabled');
        }
      });
      if (this.taffyObjects["orders"] == null) {
        this.taffyObjects["orders"] = TAFFY([]);
      }
      years = this.taffyObjects['orders']().order('year').distinct('year', 'year');
      crops = this.taffyObjects['orders']().order('crops_id').distinct('crops_id', 'crop');
      orders = this.taffyObjects['orders']().order('orders_id').distinct('orders_id', 'orders_id');
      SelectBox.render(years, $('#orders_year_filter'));
      SelectBox.render(crops, $('#orders_crop_filter'));
      SelectBox.render(orders, $('#orders_order_filter'));
      $('#btn_view_order').bind('click', (function(_this) {
        return function() {
          if ($('#orders_order_filter').val()) {
            _this.view_dlg = _this.createSubHandler('grower::handlers/rupp_orders/RuppOrdersDialogHandler');
            if (_this.view_dlg) {
              _this.view_dlg.loadLayoutPostOptions = {
                'order_id': $('#orders_order_filter').val()
              };
              _this.view_dlg.init();
              return App.sidebar.element.find('.map_sidebar_hide').click();
            }
          }
        };
      })(this));
      $('#btn_del_order').bind('click', (function(_this) {
        return function() {
          var dlg, order_id, ths;
          ths = _this;
          order_id = $('#orders_order_filter').val();
          dlg = new CancelDialog();
          if (dlg) {
            dlg.saveUrl = 'backend/grower/rupp-orders/cancel-order';
            dlg.saveData = {
              id: order_id
            };
            dlg.destroyOnYes = false;
            dlg.setContent({
              title: "Cancel Order",
              body: "Are you sure you wish to cancel this Order? This action cannot be undone.<div class='message_writer'></div>",
              yes: "Cancel Order",
              no: "Go Back"
            });
            dlg.successAction = function() {
              return _this.removeFromTaffy(order_id);
            };
            dlg.createDialog();
            return dlg.on("cancel:yes", function() {
              var ref1;
              this.dialog.find('.message_writer').message_writer().message_writer('info', 'Cancelling...');
              this.save();
              if (((ref1 = ths.view_dlg) != null ? ref1.loadLayoutPostOptions.order_id : void 0) === order_id) {
                return ths.view_dlg.destroy();
              }
            });
          }
        };
      })(this));
      $('#orders_crop_add').bind('change', function() {
        if ($(this).val()) {
          return $('#btn_add_order').removeClass('disabled');
        } else {
          return $('#btn_add_order').addClass('disabled');
        }
      });
      return $("#btn_add_order").bind('click', (function(_this) {
        return function() {
          var dlg;
          if ($('#orders_crop_add').val()) {
            dlg = _this.createSubHandler('grower::handlers/rupp_orders/RuppOrdersDialogHandler');
            if (dlg) {
              dlg.loadLayoutPostOptions = {
                'crops_id': $('#orders_crop_add').val()
              };
              dlg.init();
              return App.sidebar.element.find('.map_sidebar_hide').click();
            }
          }
        };
      })(this));
    };

    RuppOrdersHandler.prototype.removeFromTaffy = function(orders_id) {
      this.taffyObjects['orders']({
        'orders_id': {
          '==': orders_id
        }
      }).remove();
      return this.filterOrder();
    };

    RuppOrdersHandler.prototype.filterCrop = function() {
      var filter, validCrops, year;
      year = $('#orders_year_filter').val();
      filter = {};
      if (year) {
        filter.year = {
          '==': year
        };
      }
      validCrops = this.taffyObjects['orders'](filter).distinct('crops_id', 'crop');
      return SelectBox.render(validCrops, $('#orders_crop_filter'));
    };

    RuppOrdersHandler.prototype.filterOrder = function() {
      var crop, filter, validOrders, year;
      year = $('#orders_year_filter').val();
      crop = $('#orders_crop_filter').val();
      filter = {};
      if (year) {
        filter.year = {
          '==': year
        };
      }
      if (crop) {
        filter.crops_id = {
          '==': crop
        };
      }
      validOrders = this.taffyObjects['orders'](filter).order('orders_id').distinct('orders_id', 'orders_id');
      return SelectBox.render(validOrders, $('#orders_order_filter'));
    };

    RuppOrdersHandler.prototype.orderCompleted = function() {
      return this.init();
    };

    return RuppOrdersHandler;

  })(Handler);

}).call(this);
